import { render, staticRenderFns } from "./TagV2.vue?vue&type=template&id=c373a0aa&scoped=true&"
import script from "./TagV2.vue?vue&type=script&lang=js&"
export * from "./TagV2.vue?vue&type=script&lang=js&"
import style0 from "./TagV2.vue?vue&type=style&index=0&id=c373a0aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c373a0aa",
  null
  
)

export default component.exports